import React from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { bindActionCreators } from 'redux'
import { hideSidebar } from 'redux/navigation'
import { Dropdown } from 'semantic-ui-react'

const mapStateToProps = (state, ownProps) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      push,
      hideSidebar,
    },
    dispatch
  )
}

class NavigationItemDropdown extends React.Component {
  render() {
    const { items, trigger, push, hideSidebar } = this.props
    const menuItems = items.map((item) => ({
      active: item.active,
      content: item.content,
      href: item.path,
      icon: item.icon,
      key: item.key,
      size: 'small',
      onClick: (event) => {
        event.preventDefault()
        push(item.path)
        hideSidebar()
      },
    }))

    return <Dropdown className="item" trigger={trigger} options={menuItems} />
  }
}

NavigationItemDropdown = connect(mapStateToProps, mapDispatchToProps)(
  NavigationItemDropdown
)
export default NavigationItemDropdown



// WEBPACK FOOTER //
// ./src/components/shared/Navigation/renditions/NavigationItemDropdown.jsx